export const SCORING = {
  DOT: 10,
  POWER_PILL: 50,
  GHOST_EAT_COMBO: [200, 400, 800, 1600] as const,
  EXTRA_LIFE_THRESHOLD: 10_000,
  STARTING_LIVES: 3,
  MAX_LEADERBOARD_ENTRIES: 20,
} as const;

export const FRUIT_SCORES: ReadonlyArray<{
  readonly name: string;
  readonly score: number;
}> = [
  { name: 'Cherry', score: 100 },
  { name: 'Strawberry', score: 300 },
  { name: 'Orange', score: 500 },
  { name: 'Apple', score: 700 },
  { name: 'Melon', score: 1000 },
  { name: 'Galaxian', score: 2000 },
  { name: 'Bell', score: 3000 },
  { name: 'Key', score: 5000 },
] as const;
